/**
 * Biometrics Page
 *
 * Re-exports the BiometricsPage component from biometrics module.
 */

import { BiometricsPage as BiometricsPageComponent } from '../biometrics';

export default BiometricsPageComponent;
